import React, { Component } from 'react'
import Lottie from 'react-lottie';
import styled from 'styled-components';
import Loader from '../../assets/gif/loading.json';

const StyledContainer = styled.div`
    display:flex;
    height:100vh;
    width:100vw;
    justify-content:center;
    align-items:center;
    background-color:black;
`

export default class Loading extends Component {

    render(){
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: Loader,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice'
            }
          };
      
        return(
            <StyledContainer>
                <Lottie options={defaultOptions} height={300} width={300}/>
            </StyledContainer>
        )
    }
}
